import React from 'react';

const UserOrderReceipt = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);
  return (
    <div className="w-[300px] border-dotted border-2 p-4 mx-auto text-center font-sans">
      <div className="receipt-header mb-4">
        {/* Replace with your logo */}
        <img src="logo.png" alt="Logo" className="w-24 mx-auto" />
        <h2 className="text-xl font-bold mt-2">LEVANTE</h2>
        <p className="text-sm mt-1">Wed, May 27, 2020 - 9:27:53 AM</p>
      </div>

      <div className="order-number font-semibold text-lg mt-4">
        <span>Order No. 12345</span>
      </div>

      <div className="items-list mt-5">
        <p className="text-sm">Item 1</p>
        <p className="text-sm">Item 2</p>
        <p className="text-sm">Item 3</p>
      </div>

      <div className="total mt-5">
        <p className="text-sm font-bold">Amount: 950 NGN</p>
        <p className="text-sm font-bold">Tax: 50 NGN</p>
        <p className="text-sm font-bold">Total: 1000 NGN</p>
      </div>

      <div className="footer mt-5 text-xs text-gray-500">
        <p>Thanks for fueling our passion. Drop by again, if your wallet isn't still sulking. You're always welcome here!</p>
      </div>
    </div>
  );
};

export default UserOrderReceipt;
